import { useIntl } from 'react-intl';

import { formatChipDuration } from './formatChipDuration';
import messages from './messages';
import { DurationBadge, LockBadge, LockGlyph, PlayBadge, PlayGlyph, VideoGlyph } from './styles';
import { ContentChipProps } from './types';

const DEFAULT_MARGIN = 8;

const ContentChip = ({
	isLocked,
	durationSeconds,
	assetType,
	margin = DEFAULT_MARGIN,
	size = 'default',
	inline = false,
}: ContentChipProps) => {
	const intl = useIntl();
	const Glyph = assetType === 'video' ? VideoGlyph : PlayGlyph;

	if (isLocked) {
		return (
			<LockBadge
				$inline={inline}
				$margin={inline ? undefined : margin}
				$size={size}
				role="img"
				aria-label={intl.formatMessage(messages.lockedLabel)}
			>
				<LockGlyph $size={size} data-testid="lock-icon" aria-hidden />
			</LockBadge>
		);
	}

	if (durationSeconds === undefined) {
		return null;
	}

	const durationText = formatChipDuration(intl, durationSeconds);
	if (!durationText) {
		return (
			<PlayBadge $margin={margin} $size={size} data-testid="play-chip">
				<Glyph $size={size} aria-hidden />
			</PlayBadge>
		);
	}

	return (
		<DurationBadge $margin={margin} $size={size} data-testid="duration-chip">
			<Glyph $size={size} aria-hidden />
			{durationText}
		</DurationBadge>
	);
};

export default ContentChip;
